<template>
    <div id="sureveys-appeal-form">
        <div v-if="show_button" :class="'appeals-title-'+ text_button_size">
            Survey Appeal for ID: {{ call_number }} <div class="eligibility-reason-text" v-if="buttonStatus.disabled">(Not eligible because {{eligibility_reason}})</div><br>
            <b-tooltip :label="eligibility_reason">
                <b-button
                    @click="showForm = true"
                    :disabled="buttonStatus.disabled"
                    :type="buttonStatus.color"
                    :size="'is-' + text_button_size"
                >{{ buttonStatus.text }}
                </b-button><br>

            </b-tooltip>

        </div>
        <b-modal :active.sync="showForm"
                 has-modal-card
                 :destroy-on-hide="true"
                  style="color: #222"
        >
            <div class="modal-card" style="bottom: 0px; max-height: 570px; height: 100%">
                <div class="modal-card-head">
                    <h5 class="modal-card-title">Appeal Survey</h5>
                </div>
                <div class="modal-card-body">
                    <div style="text-align: left">
                        <b-field grouped>
                            <b-field label="Service Provider ID" expanded>
                                <b-input v-model="provider_id" type="text" disabled></b-input>
                            </b-field>
                            <b-field label="Service Provider Name" expanded>
                                <b-input v-model="provider_name" type="text" disabled></b-input>
                            </b-field>
                        </b-field>
<!--                        <b-field label="Service Provider Email">-->
<!--                            <b-input v-model="provider_email" type="email" disabled></b-input>-->
<!--                        </b-field>-->
                        <b-field grouped>
                            <b-field label="Service Date" expanded>
<!--                            <p class="control"><span class="button is-static"><font-awesome-icon icon="calendar"></font-awesome-icon></span></p>-->
                                <b-input v-model="service_date" disabled></b-input>
                            </b-field>
                            <b-field label="Call Number">
                                <b-input v-model="call_number" disabled></b-input>
                            </b-field>
                        </b-field>
                        <p v-if="driver_sat !== 'Totally Satisfied'" style="color: #f00; font-size: 18px; font-weight: bold;">
                            <i>Driver Satisfaction is less than Totally Satisfied for this record, so it is not eligible for appeal unless the Member is rating a different station or driver.</i>
                        </p>

                        <div>
                            <h2 style="font-size: 26px">Please select the appropriate reason:</h2>
                            <div v-for="(reasons, index) in appeals_reasons" :key="index" style="margin: 15px 0;">
                                <h3 style="font-size: 20px;">{{ reasons.label }}</h3>
                                <div class="field" v-for="(r, idx) in reasons.reasons">
                                    <b-radio :key="idx"
                                             v-model="reason" :native-value="r"
                                             :disabled="reasonDisabled(reasons.label)"
                                    >{{ r }}</b-radio></div>
                            </div>
                        </div>
                        <b-field label="Additional Notes (Optional)">
                            <b-input type="textarea" v-model="comment"></b-input>
                        </b-field>
                        <p><i>If approved as “Different Service Experience” the entire survey and all scores will be removed, even if any metrics are totally satisfied.</i></p>
                    </div>
                </div>
                <div class="modal-card-foot">
                    <b-button class="uk-button-primary" @click="startSubmitAppeals">Submit</b-button>
                    <b-button class="uk-button-secondary" @click="showForm = false">Cancel</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import apicall from "../../store/apicall";
    const be_reason = {
        'Battery Warranty Voided': 'battery_warranty_void',
        'Battery Replacement Not Eligible': 'battery_replace_not_eligible',
        'Servicing Restrictions': 'service_restriction_mandate',
        'Service Exceeds Membership Coverage Limits': 'service_exceeds_member_limits',
        'Coverage Exclusions': 'coverage_exclusion',
        'Service Requirements': 'service_requirements',
        'Incorrect Contact and Location Information': 'incorrect_info',
        'Communication Issue': 'communications_problem',
        'System/App Malfunction': 'system_malfunction',
        'Phone Connectivity': 'phone_connectivity',
        'Survey comments/answers are about an experience with a different station or driver.': 'different_driver'
    }
    export default {
        name: "AppealsForm",
        props: ['survey_id',
            'appeals_status',
            'provider_name',
            'provider_id',
            'provider_email',
            'service_date',
            'call_number',
            'eligible',
            'show_button',
            'parent_show_form',
            'driver_sat',
            'text_button_size',
            'eligibility_reason'
        ],
        data() {
            return {
                user_role: this.$store.state.user.data.position_type,
                showForm: false,
                spid: '123456789',
                spname: 'John Doe',
                spemail: 'jdoe12342@mail.com',
                spdate: '1/5/2021',
                spcallnum: '3035551234',
                reason: null,
                comment: null,
                survey_code: 5,
                appeals_reasons: [
                    {
                        label: 'Policy',
                        reasons: ['Battery Warranty Voided', 'Battery Replacement Not Eligible', 'Servicing Restrictions'],
                    },
                    {
                        label: 'Membership',
                        reasons: ['Service Exceeds Membership Coverage Limits', 'Coverage Exclusions', 'Service Requirements']
                    },
                    {
                        label: 'Agent Liability',
                        reasons: ['Incorrect Contact and Location Information', 'Communication Issue']
                    },
                    {
                        label: 'Technology',
                        reasons: ['System/App Malfunction', 'Phone Connectivity']
                    },
                    {
                        label: 'Different Service Experience',
                        reasons: ['Survey comments/answers are about an experience with a different station or driver.']
                    }
                ]
            }
        },
        methods: {
            reasonDisabled(label) {
                if (label !== 'Different Service Experience' && this.driver_sat !== 'Totally Satisfied') {
                    return true
                } else {
                    return false
                }
            },
            appealStatusButton() {
                if (this.appeals_status === 'Pending_Approval' || this.appeals_status === 'Pending_Review') return 'is-warning is-light'
                if (this.appeals_status === 'Rejected') return 'is-danger is-light'
                return 'light'
            },
            startSubmitAppeals() {
                if (this.reason === null){
                    this.$buefy.dialog.alert('You need to select a reason for the appeal.')
                } else {
                    this.submitAppeals()
                }
            },
            submitAppeals() {
                let request = {
                    survey_id: this.survey_id,
                    appeals_reason: be_reason[this.reason],
                    additional_comment: this.comment,
                    purpose: 'new_appeal'
                }
                let _t = this
                console.log('request for appeals', request)
                apicall.post('/accounts/appeal/', request)
                    .then(res => {
                        _t.showForm = false
                        _t.$emit('appealSubmitted', {survey_id: _t.survey_id})
                        _t.$buefy.snackbar.open({
                            message: 'Your appeal has been successfully been submitted. To view the status click here',
                            type: 'is-success',
                            actionText: 'Check Status',
                            onAction() {
                                _t.$emit('goToAppealsTable')
                            }
                        })
                        // do something with the data here
                    })
                .catch(err => {
                    _t.$buefy.snackbar.open({
                        message: 'Something went wrong, Appeal was not submitted.',
                        type: 'is-danger'
                    })
                })
            },
        },
        computed: {
            buttonStatus() {

                if (this.appeals_status === 'Pending_Approval' || this.appeals_status === 'Pending_Review') {
                    return {color: 'is-warning', disabled: true, text: 'Pending Review'}
                } else if (this.appeals_status === 'Rejected') {
                    return {color: 'is-danger', disabled: true, text: 'Rejected'}
                } else if (this.appeals_status === null && this.eligible === true) {
                    return {color: 'is-primary', disabled: false, text: 'Submit Appeal'}
                } else if(this.appeals_status === 'Exception_Granted') {
                    return {color: 'is-success', disabled: true, text: 'Exception Granted'}
                } else if(this.appeals_status === 'Approved') {
                    return {color: 'is-success', disabled: true, text: 'Approved'}
                } else {
                    if (this.user_role === 'Appeals-Access') {
                        return {color: 'is-default', disabled: false, text: 'Not eligible/Override'}
                    }
                    return {color: 'is-default', disabled: true, text: 'Not Eligible for Appeal'}
                }
            },
        },
        filters: {
            statusPretty(val) {
                return val.replace(/_/g, ' ')
            },
        },
        watch: {
            parent_show_form(val) {
                if (val === true) {
                    this.showForm = val
                    this.$store.dispatch('setShowModal', val)

                }
            },
            showForm(val) {
                this.$store.dispatch('setShowModal', val)
                if (val === false)
                    this.reason = null


                if (this.show_button === false && val === false) {
                    this.$emit('resetShowForm', {show: val})
                }
            }
        }
    }
</script>

<style scoped>
    .appeals-title-large {
        font-size: 26px;
        font-weight: bolder;
    }
    .appeals-title-medium {
        font-size: 18px;
        font-weight: bolder;
    }
    .modal {
        z-index: 999 !important;
    }

    .eligibility-reason-text {
        font-size: 0.5em;
    }
</style>
